import React from 'react';

import { useTranslation } from '@lt/localization';
import { HotelMapNoCoords } from '@lt/components/icons-react/map';
import styled from 'styled-components';
import HotelMapPopup from './HotelMapPopup';
import type { HotelNoCoordPopupProps } from './types';

const HotelNoCoordPopup = ({
  isMobile = false,
  onClose,
  location,
}: HotelNoCoordPopupProps) => {
  const { t } = useTranslation();
  return (
    <HotelMapPopup
      isMobile={isMobile}
      onClose={onClose}
      title={t('map.noCoords.title')}
      text={`${t('map.noCoords.text')} ${location}`}
      image={<StyledHotelMapNoCoords isMobile={isMobile} />}
    />
  );
};

const StyledHotelMapNoCoords = styled(HotelMapNoCoords)<{ isMobile: boolean }>`
  width: ${({ isMobile }) => (isMobile ? '90px' : '112px')};
`;

export default HotelNoCoordPopup;
